import styled from "styled-components";

export const ContainerCenter = styled.div`
  height: 100%;
  width: 100%;
  background-color: #eff1f5;
`;

export const TopDiv = styled.div`
  display: flex;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  min-width: 1280px;
  min-height: 720px;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const ContainerCenterInside = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  height: 2.68rem;
  margin-top: 2.5rem;
  margin-left: 2.1rem;
  user-select: none;
  margin-bottom: 1.5rem;
  z-index: 1;
`;

export const InputDiv = styled.div`
  width: 20.9rem;
  display: flex;
  align-items: center;
  height: 2.68rem;
`;
